import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { startsWithBaseUrl, stripBaseUrl } from '../../utils/routing'

import { FOOTER_LINKS_COOKIES_SETTINGS } from './translations'

import styles from './FooterLinks.module.css'

export default class FooterLinks extends React.PureComponent {
    static propTypes = {
        links: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string,
            title: PropTypes.string,
            isExternal: PropTypes.bool,
        })),
    }

    renderLinks() {
        return this.props.links.map((link) => {
            const target = link.isExternal ? '_blank' : '_top' //null  

            return (
                startsWithBaseUrl(link.href) ? (
                    <Link
                        key={ link.href }
                        to={ stripBaseUrl(link.href) }
                        state={{ lastUrl: document.location.href }}
                        className={ link.isExternal ? classNames(styles.base, styles.isExternal) : styles.base }
                        //target={ target } slug: link.slug, 
                        preventScrollReset={true}
                    >
                        {link.title}
                    </Link>
                ) : (
                    <a
                        key={link.href}
                        href={link.href}
                        className={ link.isExternal ? classNames(styles.base, styles.isExternal) : styles.base }
                        target={target}
                    >
                        {link.title}
                    </a>
                )
            )
        })
    }

    handleShowCookiesSettings = (e) => {
        e.preventDefault()

        /*if (!window.OneTrust) {
            // eslint-disable-next-line no-console
            console.error('FooterLinks.js: OneTrust is not defined')
            return
        }*/
        this.props.onOpenCookieSettings()
        //window.OneTrust.ToggleInfoDisplay()
    }

    render() {
        return (
            <nav>
                {this.renderLinks()}
                <a
                    href="##"
                    className={classNames('sdc-show-settings', styles.base)}
                    onClick={this.handleShowCookiesSettings}
                >
                    {FOOTER_LINKS_COOKIES_SETTINGS}
                </a>
            </nav>
        )
    }
}
